import { ReactNode } from 'react'

const SpotlightContainer = ({ children }: { children: ReactNode }) => {
    return (
        <div className="relative">
            <div className={'md:w-adCarousel relative right-0 top-0 z-10 flex flex-col gap-[6px] md:absolute md:gap-3'}>
                {children}
            </div>
        </div>
    )
}

export default SpotlightContainer
